<h1 mat-dialog-title>Gewichte festlegen ({{ anzahlTiere }} Tiere)</h1>

<div mat-dialog-content>
    <p>Setzen Sie Ein- und/oder Ausstallgewicht fuer alle ausgewaehlten Tiere.</p>

    <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Einstallgewicht (kg)</mat-label>
        <input matInput type="number" [formControl]="einstallgewichtCtrl" placeholder="z.B. 250" step="0.01" min="0.01" />
        <mat-error *ngIf="einstallgewichtCtrl.hasError('min')">Wert muss groesser als 0 sein.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Ausstallgewicht (kg)</mat-label>
        <input matInput type="number" [formControl]="ausstallgewichtCtrl" placeholder="z.B. 650" step="0.01" min="0.01" />
        <mat-error *ngIf="ausstallgewichtCtrl.hasError('min')">Wert muss groesser als 0 sein.</mat-error>
    </mat-form-field>

    <mat-error *ngIf="noValueErrorVisible">Bitte mindestens ein Gewicht eintragen.</mat-error>
</div>

<div class="dialog-actions" mat-dialog-actions>
    <button mat-flat-button color="accent" (click)="save()" [disabled]="isLoading">
        <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
        Speichern
    </button>

    <button mat-button (click)="close()" [disabled]="isLoading">Abbrechen</button>
</div>
